import {Component, Inject, OnInit,  ElementRef, HostListener } from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {ContractSelectorService} from '../../shared/contract-selector-service/contract-selector.service';
import {Router} from '@angular/router';
import {ContractSelectorStateService} from '../../shared/contract-selector-state-service/contract-selector-state.service';
import {Cedant, Contract, Program} from '../../shared/shared.types';

@Component({
  selector: 'app-cedant-selector-view',
  templateUrl: './cedant-selector-view.component.html',
  styleUrls: ['./_carousel.scss', './cedant-selector-view.component.scss']
})
export class CedantSelectorViewComponent implements OnInit {

  constructor(@Inject(DOCUMENT) public document: HTMLDocument,
              private elementRef: ElementRef,
              private provider:                  ContractSelectorService,
              private router:                    Router,

              public contractSelectorState:      ContractSelectorStateService) { }


  slides: any = [[]];

  programs:         Program[]  = [];
  selectedProgram:  Program    = null;

  cedants:          Cedant[];
  selectedCedant:   Cedant     = null;

  contracts:        Contract[] = [];
  selectedContract: Contract   = null;

  @HostListener('window:resize')
  onResize() {
    const visibleSlides = this.visibleSlides();
    const cedants = [...this.cedants];  // clone cedants, it maybe other way - but I dont have time for dig fufter
    this.slides = this.trimData(cedants, visibleSlides);
  }

  ngOnInit() {

    this.provider
      .getAllCedants()
      .subscribe(result => {
        this.cedants = result;
        this.contractSelectorState.currentContracts =  result;
        const visibleSlides = this.visibleSlides();
        const cedants = [...this.cedants];    // clone cedants, it maybe other way - but I dont have time for dig fufter
        this.slides = this.trimData(cedants, visibleSlides);
      });


    this.contractSelectorState
      .cedant$
      .subscribe( cedant => {
        this.selectedCedant = cedant;
      });


    this.contractSelectorState
      .program$
      .subscribe( p => {
        this.selectedProgram = p;
      });


    this.contractSelectorState
      .contract$
      .subscribe( c => {
        this.selectedContract = c;
      });
  }

  pickCedant(cedant: Cedant) {
    if (this.selectedCedant) {
      this.selectedCedant.isSelected = false;
    }
    this.selectedCedant = cedant;
    this.selectedCedant.isSelected = true;
    this.contractSelectorState.currentCedant = cedant;
    this.contractSelectorState.setCedantActive();

    // setup program to element 0
    if (cedant.programs[0]) {
      if (this.selectedProgram) {
        this.selectedProgram.isSelected = false;
      }
      this.selectedProgram = cedant.programs[0];
      this.selectedProgram.isSelected = true;
      this.contractSelectorState.currentProgram = cedant.programs[0];
      this.contractSelectorState.setProgramActive();
    }

    this.router.navigate(['cedant', cedant.id || 0]);
  }


  trimData(array, size) {
    console.log(array);
    let results = [];
    results = [];
    while (array.length) {
      results.push(array.splice(0, size));
    }
    return results;
  }


  private visibleSlides() {

    let maxVisibleSlides = 3;
    const documentWidth = this.elementRef.nativeElement.ownerDocument.documentElement.clientWidth;
    if (documentWidth < 768) {
      maxVisibleSlides = 1;
    } else if (documentWidth > 768) {
      maxVisibleSlides = 3;
    }
    return maxVisibleSlides;
  }

  swipe() {
  }

  pause() {

  }
  play() {

  }
  previousSlide() {

  }
  nextSlide() {

  }

  selectSlide() {

  }

  isLast() {
  }

}
